"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _lodash = _interopRequireDefault(require("lodash"));

var _ampApi = require("@amplify/amp-api");

/**
 * This service provides methods for debouncing updates to realtime records.
 *
 * This ensures that rapid publish calls triggering updates to a certain record
 * only perform the last update in the series, fixing a race condition in which
 * updates could complete out of order and result in unexpected record data.
 * See PI-208 for more details.
 */
var DEBOUNCE_WAIT = 200; // ms

var StorageService = /*#__PURE__*/function () {
  function StorageService() {
    (0, _classCallCheck2.default)(this, StorageService);
    (0, _defineProperty2.default)(this, "debouncedFunctions", void 0);
    this.debouncedFunctions = {};
  }
  /**
   * Debounce classroomState record updates. Debounced functions are keyed
   * by classKey and recordType.
   */


  (0, _createClass2.default)(StorageService, [{
    key: "saveClassroomState",
    value: function saveClassroomState(classKey, recordType, data) {
      return this.callDebounced(_ampApi.saveClassroomState, classKey, recordType, data);
    }
    /**
     * Debounce user record updates. Debounced functions are keyed by userId
     * and recordType.
     */

  }, {
    key: "saveUserFile",
    value: function saveUserFile(userId, recordType, data) {
      return this.callDebounced(_ampApi.saveUserFile, userId, recordType, data);
    }
    /**
     * Call debounced version of a record update function.
     */

  }, {
    key: "callDebounced",
    value: function callDebounced(originalFn, recordKey, recordType, data) {
      var debouncedFn = _lodash.default.get(this.debouncedFunctions, "".concat(recordKey, ".").concat(recordType));

      if (!debouncedFn) {
        debouncedFn = _lodash.default.debounce(function (recordKey, recordType, data, resolve) {
          return originalFn(recordKey, recordType, data).then(resolve);
        }, DEBOUNCE_WAIT);

        _lodash.default.set(this.debouncedFunctions, "".concat(recordKey, ".").concat(recordType), debouncedFn);
      } // Wait until a persistence call is actually
      // made before resolving promise.


      return new Promise(function (resolve) {
        return debouncedFn(recordKey, recordType, data, resolve);
      });
    }
  }]);
  return StorageService;
}();

var _default = new StorageService();

exports.default = _default;
//# sourceMappingURL=storageService.js.map